// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zAF7L2eHGK5hydOM_ucx .M7nvyDt0V7Uey_vLIXJM {
  height: calc(100vh - 258px);
  overflow: auto;
}
.zAF7L2eHGK5hydOM_ucx .kxPr4UnxEhhrb_Re30H0 {
  color: #7d8592;
}
.zAF7L2eHGK5hydOM_ucx .adO72TsEzNl6cu1LBXe0 {
  width: 28px;
  height: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Item/Projects/index.module.less"],"names":[],"mappings":"AACA;EAEI,2BAAA;EACA,cAAA;AADJ;AAFA;EAOI,cAAA;AAFJ;AALA;EAWI,WAAA;EACA,YAAA;AAHJ","sourcesContent":["\n.container {\n  .list {\n    height: calc(100vh - 258px);\n    overflow: auto;\n  }\n\n  .personal {\n    color: #7d8592;\n  }\n\n  .item-setting {\n    width: 28px;\n    height: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zAF7L2eHGK5hydOM_ucx`,
	"list": `M7nvyDt0V7Uey_vLIXJM`,
	"personal": `kxPr4UnxEhhrb_Re30H0`,
	"item-setting": `adO72TsEzNl6cu1LBXe0`
};
export default ___CSS_LOADER_EXPORT___;
